<template>
  <div>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-show="emailSignature"
      :class="{ show: emailSignature }"
    >
      <div style="max-width: 845px" class="cstm-modal">
        <div class="header justify-between">
          <h4>Email Signature</h4>
          <button @click.stop="closeModal" class="close-modal">
            &times;
          </button>
        </div>
        <div class="modal-content">
          <div class="p-4 border_btm relative">
            <label style="min-width: 100px">Name</label>
            <div class="inline-flex items-center w-full py-2">
              <vs-input
                v-model="signature_name"
                placeholder="Enter signature name"
                class="w-full"
              />
            </div>
            <label style="min-width: 100px">Description</label>
            <div class="inline-flex items-center w-full py-2">
              <vs-input
                v-model="signature_description"
                placeholder="Enter description"
                class="w-full"
              />
            </div>
            <div class="py-2">
              <editor
                v-model="signature_body"
                :api-key="tinyMceApi"
                :init="initTinyMce"
              />
            </div>
            <vs-checkbox
                :checked="is_default_signature"
                v-model="is_default_signature"
                >Mark as default</vs-checkbox
              >
          </div>

          <div class="text-right p-4">
            <vs-button type="border" class="mr-2" @click="sendSaveEmail()">{{
              signature_details ? "Update" : "Save"
            }}</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getRelatedRecords,
  emailSignatureCreate,
  emailSignatureEdit
} from '@/api/email'
import vSelect from 'vue-select'
import Editor from '@tinymce/tinymce-vue'
import { shortCourseList } from '@/api/admission'

import { getClassListWithoutPagination } from '@/api/classes'
import { Lead_list } from '@/api/leads'

export default {
  components: {
    vSelect,
    Editor
  },
  props: {
    emailSignature: {
      default: false
    },
    type: {
      default: ''
    },
    signature_details: {
      default: null
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
  },
  watch: {
  },
  mounted () {
    if (this.signature_details) {
      this.signature_name = this.signature_details.title
      this.signature_body = this.signature_details.body
      this.signature_description = this.signature_details.desc
      this.is_default_signature = this.signature_details.is_default
    }
  },
  data () {
    return {
      signature_name: '',
      signature_body: '',
      signature_description: '',
      is_default_signature: 0,
      addCC: false,
      external_users: '',
      fieldCodes: [],
      sendEmailToUsers: [],
      teacher_ids: [],
      parentlist: [],
      student_ids: [],
      parents_ids: [],
      filterPayload: {
        course_id: [],
        class_id: [],
        crm_id: []
      },
      observerCourse: new IntersectionObserver(this.loadMoreCourses),
      observerClass: new IntersectionObserver(this.loadMoreClass),
      observerCRM: new IntersectionObserver(this.loadMoreCRM),

      customer_id: localStorage.getItem('customer_id'),
      templateList: false,
      dynamicList: false,
      tinyMceApi: '',
      courseList: [],
      classList: [],
      crm_list: [],
      studentlist: [],
      teacherList: [],
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      class_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      crm_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      parent_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 300,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor |           table alignleft aligncenter alignright alignjustify |           bullist numlist outdent indent | removeformat | help'
      },
      external_users_arr: [],
      external_users_cc: ''
    }
  },
  methods: {
    async sendSaveEmail () {
      const emailPayload = {
        title: this.signature_name,
        desc: this.signature_description,
        body: this.signature_body,
        is_default: this.is_default_signature ? 1 : 0
      }
      try {
        this.$vs.loading()
        // eslint-disable-next-line no-unused-vars
        if (!this.signature_details) {
          await emailSignatureCreate(this.customer_id, emailPayload)
        } else {
          await emailSignatureEdit(
            this.customer_id,
            this.signature_details.id,
            emailPayload
          )
        }
        this.clearComposeEmail()
        this.$vs.notify({
          title: 'Success',
          text: `Email signature ${
            this.signature_details ? 'updated' : 'created'
          } successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.$emit('closeNfetch', true)
      } catch (error) {
        console.log(error)
        let errorText = error.data.errors
        if (error.data.errors.body) {
          errorText = 'Body is required'
        } else if (error.data.errors.to_users) {
          errorText = 'To users is required'
        } else if (error.data.errors.subject) {
          if (
            error.data.errors.subject[0] ===
            'The subject may not be greater than 255 characters.'
          ) {
            errorText = error.data.errors.subject[0]
          } else {
            errorText = 'Subject is required'
          }
        }

        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    clearComposeEmail () {
      this.emailSubject = ''
      this.emailBody = ''
      this.filterModule = ''
    },
    async loadMoreCourses () {
      try {
        const payload = {}
        this.course_list_meta.current_page =
          this.course_list_meta.current_page + 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload,
          this.course_list_meta
        )
        this.courseList.push(...data.data.course_list)
        this.course_list_meta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCourse () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.loadCourse)
      }
    },
    onCloseCourse () {
      this.observerCourse.disconnect()
    },
    async fetchCourseList () {
      const payload = {}
      this.course_list_meta.current_page = 1
      const { data } = await shortCourseList(
        localStorage.getItem('customer_id'),
        payload,
        this.course_list_meta
      )
      this.courseList = data.data.course_list

      this.course_list_meta = data.data.meta
    },
    async fetchClassList () {
      const { data } = await getClassListWithoutPagination(
        this.customer_id,
        this.class_meta
      )

      this.classList = data.data.class_short_list.data
      this.class_meta = data.data.meta
      this.class_meta.page = data.data.meta.current_page
    },
    async onOpenClass () {
      if (this.class_meta.has_next) {
        await this.$nextTick()
        this.observerClass.observe(this.$refs.loadClass)
      }
    },
    onCloseClass () {
      this.observerClass.disconnect()
    },
    async loadMoreClass () {
      try {
        this.class_meta.page = this.class_meta.page + 1

        const data = await getClassListWithoutPagination(
          this.customer_id,
          this.class_meta
        )
        this.classList.push(...data.data.data.class_short_list.data)
        this.class_meta = data.data.data.meta
        this.class_meta.page = data.data.data.meta.current_page
        console.log(this.classList)
      } catch (e) {
        //
      }
    },
    async fetchCrmList () {
      try {
        const payload = {
          ...this.crm_meta,
          customerId: this.customer_id
        }
        const { data } = await Lead_list(payload)

        this.crm_list = data.data.results
        this.crm_meta = data.data.meta
        this.crm_meta.page = data.data.meta.current_page
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenCRM () {
      if (this.crm_meta.has_next) {
        await this.$nextTick()
        this.observerCRM.observe(this.$refs.loadCRM)
      }
    },
    onCloseCRM () {
      this.observerCRM.disconnect()
    },
    async loadMoreCRM () {
      try {
        this.crm_meta.page = this.crm_meta.page + 1

        const payload = {
          ...this.crm_meta,
          customerId: this.customer_id
        }
        const { data } = await Lead_list(payload)

        this.crm_list.push(...data.data.results)
        this.crm_meta = data.data.meta
        this.crm_meta.page = data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    closeModal () {
      this.$emit('closeEmailTempalatePopup', true)
    },
    async getRelatedRecords () {
      try {
        const payload = {
          customer_id: this.customer_id,
          module_id: this.filterModule.id
        }

        const response = await getRelatedRecords(payload)
        this.fieldCodes = response.data.data.module_related_dynamic_field
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>